export default `
<div>
  <p><strong>1. Insights in AI evolution</strong></p>

  <p>
    Dr. <a href="https://www.linkedin.com/in/lijiali/">Jia Li</a>, co-founder of
    <a href="https://livex.ai/">LiveX.AI</a> and former Head of R&amp;D at
    Google Cloud AI, provided an insightful overview of AI’s evolution from deep
    learning to generative AI. She shared her experience at Snap, where she
    successfully compressed models for real-time mobile applications. Dr. Li
    emphasized the vast opportunities in traditional industries, urging them to
    adopt AI for innovation and growth.
  </p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture1.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
  </p>

  <p>
    Founded in 2023, LiveX.AI aims to revolutionize everyday interactions with
    generative multimodal AI. Their AI Copilot sees, hears, chats, and displays
    information, enriching user interaction with digital environments. This
    technology has immense potential in customer service and home management,
    enhancing user experiences with optimized models and robust data processing.
  </p>

  <p><strong>2. Learning from AI Leaders – Nvidia</strong></p>

  <p>
    <a href="https://www.nvidia.com/en-us/">Nvidia</a>, an early leader in AI,
    strategically shifted towards AI computing, providing full-stack solutions
    from foundational chips to a robust software ecosystem. Collaborating with
    tech giants like Microsoft and Amazon, Nvidia has built a powerful AI
    infrastructure that supports advanced AI models.
  </p>

  <p class="img">
    <span style="width: 500px"
      ><span
        ><img
          src="/storage/app/media/uploaded-files/Picture2.png"
          data-result="success"
          style="width: 500px" /></span
    ></span>
    <span class="img_info">Nvidia executives giving a showroom tour.</span>
  </p>


  <p class="img">
    <span style="width: 500px"
      ><span class="fr-img-wrap"
        ><img
          src="/storage/app/media/uploaded-files/Picture3.png"
          data-result="success"
          style="width: 500px" /><span class="fr-inner"></span></span
    ></span>
    <span  class="img_info">Engaging with research scientists.</span>
  </p>
  <p><strong>3. Exploring the AI Industry Chain from Our Ecosystem</strong></p>

  <p>
    We visited our portfolio companies
    <a href="https://www.tetramem.com/">TetraMem</a>,
    <a href="https://pixocial.com/">Pixocial</a>, and
    <a href="https://www.pingcap.com/">PingCAP,</a> gaining insights into their
    cutting-edge AI technologies and strategies. These visits highlighted the
    innovative work within our ecosystem and reinforced our commitment to
    supporting breakthrough advancements.
  </p>

  <p class="img">
    <span class="fr-img-caption fr-fic fr-dib fr-fil" style="width: 500px"
      ><span class="fr-img-wrap"
        ><img
          src="/storage/app/media/uploaded-files/Picture4.png"
          data-result="success"
          style="width: 500px"
        /><span class="fr-inner"
          ><br />

          TetreMem</span
        ></span
      ></span
    >
  </p>

  <p class="img">
    <span class="fr-img-caption fr-fic fr-dib" style="width: 500px"
      ><span class="fr-img-wrap"
        ><img
          src="/storage/app/media/uploaded-files/Picture5.png"
          data-result="success"
          style="width: 500px" /><span class="fr-inner"></span></span
    ></span>
    <span  class="img_info">Pixocial</span>
  </p>

  <p class="img">
    <span class="fr-img-caption fr-fic fr-dii" style="width: 500px"
      ><span class="fr-img-wrap"
        ><img
          src="/storage/app/media/uploaded-files/Picture6.png"
          data-result="success"
          style="width: 500px" /><span class="fr-inner"></span></span
    ></span>
    <span  class="img_info">PingCAP</span>
  </p>

  <p>
    <br />
  </p>

  <p><strong>4. Insights from Leading Silicon Valley Startups</strong></p>

  <p>
    <a href="https://huggingface.co/">Hugging Face</a> is celebrated for its
    open-source ethos and robust support for the LLM community. They provide
    developers with a comprehensive suite of tools and resources, including the
    industry-standard Transformers library for LLMs and other machine learning
    tasks.
  </p>

  <p class="img">
    <span style="width: 500px"
      ><span
        ><img
          src="/storage/app/media/uploaded-files/Picture7.png"
          data-result="success"
          style="width: 500px" /></span
    ></span>
    <span class="img_info">>Hugging Face</span>
  </p>
  <p>
    <a href="https://mobile-aloha.github.io/">Mobile ALOHA</a> is a home robot
    developed in collaboration with Stanford University, UC Berkeley, and the
    Google DeepMind team. As a proof-of-concept project, it aims to (1)
    demonstrate the feasibility of imitation learning in robotic mobility, and
    (2) advance algorithm research through open-source software and hardware.
    More than just a home assistant, Mobile ALOHA can perform various household
    tasks such as laundry, cleaning, gardening, and pet care. The team is led by
    Stanford computer science PhD students
    <a href="https://www.linkedin.com/in/zipengfu/">Zipeng Fu</a> and
    <a href="https://www.linkedin.com/in/tony-z-zhao/">Tony Z. Zhao</a>.
  </p>

  <p class="img">
    <span class="fr-img-caption fr-fic fr-dib" style="width: 500px"
      ><span class="fr-img-wrap"
        ><img
          src="/storage/app/media/uploaded-files/Picture8.png"
          data-result="success"
          style="width: 500px" /><span class="fr-inner"></span></span
    ></span>
    <sapn>Mobile ALOHA</sapn>
  </p>


  <p>
    <a href="https://traini.app/">Traini</a> is an AI-powered company
    specializing in personalized pet training. Their app provides custom
    training plans, instructional videos, essential skills, behavioral commands,
    and individual pet schedules. This platform helps pet owners achieve
    training goals and strengthen bonds with their pets.
  </p>

  <p class="img">
    <span class="fr-img-caption fr-fic fr-dib" style="width: 500px"
      ><span class="fr-img-wrap"
        ><img
          src="/storage/app/media/uploaded-files/Picture9.png"
          data-result="success"
          style="width: 500px" /><span class="fr-inner"></span></span
    ></span>
    <span class="img_info">Traini</span>
  </p>


  <p><strong>5. AI x Companionship Demo Day</strong></p>

  <p>
    In the new AI era, the greatest opportunities lie in fulfilling higher human
    needs such as emotional support and self-actualization. AI-driven emotional
    companionship models are creating disruptive market opportunities. We
    invited founders in this space to share their innovative ideas and insights.
  </p>

  <p class="img">
    <img src="/storage/app/media/uploaded-files/Picture10.png" style="width:
    500px" class="fr-fic fr-dib fr-fil" data-result="success"
  </p>

  <p><strong>6. Silicon Valley Founders Meetup</strong></p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture11.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
  </p>

  <p><strong>7. Exchange with Renowned Incubator Plug and Play</strong></p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture12.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
  </p>

  <p><strong>8. Visit to the Computer History Museum</strong></p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture13.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
  </p>

  <p>
    As part of our trip, we visited the Computer History Museum to explore the
    technological evolution from the 1960s to the present. We traced the journey
    from Fairchild Semiconductor’s silicon transistor, through the development
    of chip technology, personal computers, the software industry, the internet,
    cloud computing, and smartphones. Recent AI advancements were highlighted
    for their potential in solving real-world problems and promoting
    sustainability. This visit enriched our understanding of how these
    interconnected evolutions of technologies shape today’s tech landscape.
  </p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture14.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
    <span  class="img_info">Our Takeaways:</span>
  </p>
  <p>
    · Technological advancements require sustained accumulation, with hardware
    leading and software following. Overnight success is rare. Most current
    innovations are incremental, favoring established giants. While AI enhances
    capabilities, its impact differs significantly from the organizational
    transformation seen with mobile internet. Nonetheless, AI’s evolution will
    create new opportunities for growth, such as in smart vehicles, laying the
    foundation for future expansion.
  </p>
  <p>
    · The current tech wave, driven by GPUs, has unlocked significant
    application potential. Established companies thrive, but new entrants
    continuously emerge. Capturing key opportunities can lead to major success
    in the new tech landscape. Regardless of breakthrough innovations, products
    that meet the current market needs will always find success, even if they
    are transitional.
  </p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture15.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
  </p>

  <p><strong>9. Beyond Insights</strong></p>

  <p class="img">
    <img
      src="/storage/app/media/uploaded-files/Picture16.png"
      style="width: 500px"
      class="fr-fic fr-dib fr-fil"
      data-result="success"
    />
  </p>

  <p>
    Beyond intense knowledge exchange, we also experienced the integration of
    technology and life by choosing Waymo self-driving cars for our
    transportation in San Francisco.
  </p>

  <p><strong>10. Investor Feedback and Reflections</strong></p>

  <p>
    The trip provided rich experiences in technology and innovation, along with
    valuable investor feedback. Here are some key insights and suggestions:
  </p>

  <ul>
    <li>
      “Despite the exhausting schedule, I thoroughly enjoyed working with the
      FutureX team and look forward to more collaboration. Their persistence in
      doing the right things will undoubtedly yield significant rewards.”
    </li>

    <li>
      “Thank you for organizing this trip. It introduced me to exceptional
      entrepreneurs with impressive innovation and potential. I recommend
      regular follow-ups to maintain contact, track their progress, and seize
      timely investment opportunities.”
    </li>

    <li>
      “We should organize more trips like this. Meeting talented, passionate
      young innovators was deeply impressive. These trips help us better
      understand cutting-edge technology trends and identify promising
      investment opportunities."
    </li>

    <li>
      " The trip was well organized. We must adjust our expectations—while the
      sector is promising, timing is crucial. Many projects demonstrated strong
      entrepreneurial enthusiasm, so we need to identify opportunities with calm
      and rationality. In a hot market, maintaining objectivity is key."
    </li>

    <li>
      “The recent trip was incredibly efficient, providing valuable insights
      into Silicon Valley’s latest tech and market trends. The team operated
      with precision and effectiveness, unlike others who often review hundreds
      of projects without investing or lack on-the-ground presence. This
      experience has sharpened our understanding of the B2B market, and we are
      now better positioned to identify and pursue promising investment
      opportunities in this space.”
    </li>
  </ul>

  <p><strong>11. Future Outlook</strong></p>

  <p>
    Our recent Silicon Valley tour was intense and rewarding, deepening our
    understanding of cutting-edge technology and gathering valuable investor
    feedback. We appreciate the full support from our investors and partners
    throughout this journey. Despite the packed schedule, enthusiasm remained
    high and discussions were vibrant.
  </p>

  <p>
    For investors, this trip offered a unique glimpse into global tech
    innovation, refining investment strategies and directions. FutureX is
    dedicated to advancing technology and innovation, continuously optimizing
    our investment approach. We look forward to reconnecting at our next
    destination to explore the future of tech together.Staying true to our
    open-source value, we will keep sharing key insights—stay tuned.
  </p>
</div>
`;
